import { useBizApiClient } from "../_base/useBizApiClient";
const useAuditorEvaluateShareClient = () => {
  const [evaluateShare, result] = useBizApiClient({
    name: `evaluateAuditorShare`,
    method: "get",
    path: `/auditor/evaluate`
  });
  return [evaluateShare, result];
};
const useAuditorEvalStateClient = () => {
  const [setEvalState, result] = useBizApiClient({
    name: `auditorEvalState`,
    method: "post",
    path: `/auditor/evaluate/step/setEvalState`
  });
  return [setEvalState, result];
};
const useAuditorActionStateClient = () => {
  const [setActionState, result] = useBizApiClient({
    name: `auditorActionState`,
    method: "post",
    path: `/auditor/evaluate/step/setActionState`
  });
  return [setActionState, result];
};
const useAuditorAddEvalNoteClient = () => {
  const [addEvalNote, result] = useBizApiClient({
    name: `auditorAddEvalNotes`,
    method: "post",
    path: `/auditor/evaluate/step/addEvalNote`
  });
  return [addEvalNote, result];
};
export { useAuditorEvaluateShareClient, useAuditorEvalStateClient, useAuditorActionStateClient, useAuditorAddEvalNoteClient };